import React from 'react';
import { CTAButton } from './CTAButton';
export function Footer() {
  return <footer className="bg-navy-950 px-4 pb-32 pt-14 sm:px-6 sm:pb-36 sm:pt-16" data-id="element-172" data-mp="3gezcj1s77n03">
      <div className="mx-auto w-full max-w-3xl text-center" data-id="element-173" data-mp="3gh3rcermy6f5">
        <p className="font-display text-xl font-bold text-cream-50 sm:text-2xl" data-id="element-174" data-mp="32p5lcct80qn7">
          Complex Rehab Case Audit™
        </p>
        <p className="mt-2 text-sm text-cream-100/70" data-id="element-175" data-mp="36nd75m2jki59">
          Audit the 7 critical areas. Organize your review. Know what deserves a
          closer look.
        </p>
        <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.18em] text-gold-400" data-id="element-176" data-mp="37fpks21w7ww">
          Created by Dr. Karito
        </p>

        <div className="mt-9" data-id="element-177" data-mp="3qdf5796vj4bp">
          <CTAButton label="Get the Complex Rehab Case Audit™ — $27" subLabel="One-time payment · Instant access · 7-day guarantee" data-id="element-178" data-mp="3qcniyoz62iy3" />
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-[11px] leading-relaxed text-cream-100/45" data-id="element-179" data-mp="2ey05hxna5ycw">
          Educational material only. This product is intended to support clinical
          education and organization. It does not provide diagnosis or
          patient-specific treatment recommendations and does not replace
          professional clinical judgment, clinical examination, diagnosis,
          treatment planning, continuing education or applicable standards of
          care. All clinical decisions must be made by the responsible licensed
          clinician based on the individual patient and applicable professional
          requirements.
        </p>
        <p className="mt-5 text-[11px] text-cream-100/40" data-id="element-180" data-mp="31umvaqetzm7">
          © 2026 Dr. Karito. All rights reserved.
        </p>
      </div>
    </footer>;
}